<script>
import "flatpickr/dist/flatpickr.css";
import Layout from "../../layouts/main.vue";
import calendar from "../../components/calendar.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from "axios";
import jwt_decode from "jwt-decode";

const DAYS = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];
const DAY_LABELS = { monday:'Monday', tuesday:'Tuesday', wednesday:'Wednesday', thursday:'Thursday', friday:'Friday', saturday:'Saturday', sunday:'Sunday' };

export default {
  page: {
    title: "Calendario de Agencia",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    PageHeader,
    calendar,
  },
  data() {
    return {
      items: [
        { text: "Calendar", href: "/" },
        { text: "Agencia", active: true },
      ],
      isSuperAdmin: false,
      isAdmin: false,
      isLeaderOrRecruiter: false,
      isTeacher: false,
      departmentID: null,
      departments: [],
      selectedDept: null,
      
      // Schedule config
      showScheduleModal: false,
      isTeacherConfig: false,
      scheduleLoading: false,
      scheduleSaving: false,
      scheduleSaved: false,
      scheduleConfig: Object.fromEntries(DAYS.map(d => [d, []])),
      newSlot: Object.fromEntries(DAYS.map(d => [d, ''])),
      scheduleDeptId: null,
      isDarkMode: false,
      meetingLink: '',
      meetingPassword: '',
    };
  },
  computed: {
    days() { return DAYS; },
    dayLabels() { return DAY_LABELS; },
    currentDepartmentName() {
      if (this.departments.length && this.departmentID) {
        const found = this.departments.find(d => Number(d.departmentID) === Number(this.departmentID));
        if (found && found.name) {
          return found.name;
        }
      }
      return "Mi Departamento";
    },
  },
  watch: {
    showScheduleModal(val) {
      if (!val) {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('modal-open');
      }
    },
  },
  methods: {
    checkAdminRole() {
      const jwt = localStorage.getItem("jwt");
      if (!jwt) return;
      try {
        const decoded = jwt_decode(jwt);
        const group = decoded.userGroup || decoded.userGroupCode || "";
        const views = decoded.vueViews || [];
        this.isSuperAdmin = group.includes("SUPER_ADMIN_GROUP");
        this.isAdmin = group.includes("SUPER_ADMIN_GROUP") || group.includes("ADMIN_GROUP");
        this.isLeaderOrRecruiter = group.includes("LEADER") || group.includes("RECRUITER") || group.includes("MANAGER") || group.includes("ADMIN_GROUP");
        this.isTeacher = this.isSuperAdmin || views.includes("EDIT_LICENSE_CLASS");
        this.departmentID = decoded.departmentID ? Number(decoded.departmentID) : null;
      } catch (e) {
        this.isSuperAdmin = false;
        this.isAdmin = false;
        this.isLeaderOrRecruiter = false;
        this.isTeacher = false;
        this.departmentID = null;
      }
    },
    async loadDepartments() {
      try {
        const response = await axios.post('/api/listDepartments', {
          token: localStorage.getItem('jwt')
        });
        if (response.data !== 'void') {
          let depts = [];
          if (Array.isArray(response.data)) {
            depts = response.data.filter(d => d && d.departmentID);
          } else if (typeof response.data === 'object' && response.data !== null && response.data.departmentID) {
            depts = [response.data];
          }
          this.departments = depts;
          if (this.isSuperAdmin) {
            this.selectedDept = 'ALL';
          } else {
            this.selectedDept = this.departmentID ? String(this.departmentID) : (depts.length > 0 ? String(depts[0].departmentID) : null);
            if (!this.departmentID && depts.length > 0) {
              this.departmentID = depts[0].departmentID;
            }
          }
        }
      } catch (error) {
        console.error("Error loading departments:", error);
      }
    },
    // Schedule Config Methods
    openScheduleConfig(isTeacher = false) {
      if (isTeacher && !this.isTeacher) return;
      this.isTeacherConfig = isTeacher;
      this.showScheduleModal = true;
      this.scheduleLoading = true;
      this.scheduleConfig = Object.fromEntries(DAYS.map(d => [d, []]));
      
      if (isTeacher) {
        this.scheduleDeptId = 0;
      } else {
        if (this.isSuperAdmin) {
          if (this.departments.length > 0 && (!this.scheduleDeptId || this.scheduleDeptId === 0)) {
            this.scheduleDeptId = this.departments[0].departmentID;
          }
        } else {
          this.scheduleDeptId = this.departmentID;
        }
      }
      this.loadSchedule();
    },
    loadSchedule() {
      if (!this.scheduleDeptId || this.scheduleDeptId === 'ALL') {
        this.scheduleLoading = false;
        return;
      }
      this.scheduleLoading = true;
      axios.get('/api/department-schedule', {
        params: { token: localStorage.getItem('jwt'), departmentID: this.scheduleDeptId },
      }).then(res => {
        this.scheduleConfig = res.data.schedule || Object.fromEntries(DAYS.map(d => [d, []]));
        this.meetingLink = res.data.meetingLink || '';
        this.meetingPassword = res.data.meetingPassword || '';
      }).catch(() => {
        this.scheduleConfig = Object.fromEntries(DAYS.map(d => [d, []]));
        this.meetingLink = '';
        this.meetingPassword = '';
      }).finally(() => {
        this.scheduleLoading = false;
      });
    },
    addSlot(day) {
      const val = (this.newSlot[day] || '').trim();
      if (!val || val.length !== 5 || val[2] !== ':') return;
      if (!this.scheduleConfig[day].includes(val)) {
        this.scheduleConfig[day] = [...this.scheduleConfig[day], val].sort();
      }
      this.newSlot[day] = '';
    },
    removeSlot(day, index) {
      this.scheduleConfig[day].splice(index, 1);
    },
    formatSlot(time) {
      const [h, m] = time.split(':').map(Number);
      const p = h < 12 ? 'AM' : 'PM';
      const h12 = h > 12 ? h - 12 : h === 0 ? 12 : h;
      return `${h12}:${String(m).padStart(2,'0')} ${p}`;
    },
    async saveSchedule() {
      this.scheduleSaving = true;
      try {
        await axios.post('/api/department-schedule/save', {
          token: localStorage.getItem('jwt'),
          departmentID: this.scheduleDeptId,
          schedule: this.scheduleConfig,
          meetingLink: this.meetingLink,
          meetingPassword: this.meetingPassword,
        });
        this.scheduleSaved = true;
        setTimeout(() => { this.scheduleSaved = false; }, 3000);
      } catch (e) {
        alert('Error saving schedule. Please try again.');
      } finally {
        this.scheduleSaving = false;
      }
    },
  },
  async mounted() {
    this.checkAdminRole();
    await this.loadDepartments();
    this.isDarkMode = document.documentElement.getAttribute('data-layout-mode') === 'dark';
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('t-agency-calendar')" :items="items"/>

    <!-- Header bar for Admins and Leaders -->
    <div v-if="(isSuperAdmin && departments.length) || (departmentID && (isAdmin || isLeaderOrRecruiter)) || isTeacher" class="row mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body py-3 d-flex align-items-center gap-3 flex-wrap">
            
            <!-- Super Admin Filter (Allows switching departments) -->
            <div v-if="isSuperAdmin" class="d-flex align-items-center gap-2" style="flex: 0 0 auto; max-width: 380px;">
              <label for="deptSelect" class="form-label mb-0 text-nowrap fw-semibold">
                <i class="ri-team-line me-1 text-primary"></i> {{ $t('t-leader-interviews') }}:
              </label>
              <select class="form-select" id="deptSelect" v-model="selectedDept">
                <option value="ALL">ALL (Todos los líderes)</option>
                <option v-for="dept in departments" :key="dept.departmentID" :value="String(dept.departmentID)">
                  {{ dept.name }}
                </option>
              </select>
            </div>
            
            <!-- Non-SuperAdmin Title (Fixed to their own department) -->
            <div v-else class="d-flex align-items-center gap-2" style="flex: 0 0 auto;">
              <span class="fw-semibold text-primary fs-14">
                <i class="ri-team-line me-1"></i> {{ currentDepartmentName }}
              </span>
            </div>

            <div class="d-flex gap-3 align-items-center ms-auto flex-wrap">
              <span class="badge fs-12 p-2" style="background-color: rgba(101, 89, 204, 0.15); color: #8772f9; border: 1px solid rgba(101, 89, 204, 0.35);">
                <i class="ri-book-open-line me-1"></i> License Classes
              </span>
              <span class="badge bg-soft-success text-success fs-12 p-2">
                <i class="ri-checkbox-blank-circle-fill me-1" style="color: #0ab39c;"></i>
                Leader Availability
              </span>
              <span class="badge bg-soft-warning text-warning fs-12 p-2">
                <i class="ri-calendar-event-line me-1"></i> Leader Interviews
              </span>
            </div>
            
            <button v-if="isAdmin || isLeaderOrRecruiter" type="button" class="btn btn-soft-success btn-sm ms-3" @click="openScheduleConfig(false)">
              <i class="ri-settings-3-line align-bottom me-1"></i> Interview Schedule Config
            </button>
            <button v-if="isTeacher" type="button" class="btn btn-sm ms-3" style="background-color: rgba(101, 89, 204, 0.15); color: #8772f9; border: 1px solid rgba(101, 89, 204, 0.35);" @click="openScheduleConfig(true)">
              <i class="ri-book-open-line align-bottom me-1"></i> Teacher Schedule Config
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Single combined calendar — wait for selectedDept if super admin -->
    <calendar
      v-if="!isSuperAdmin || selectedDept"
      mode="combined"
      :department-id="selectedDept"
      :is-admin="isAdmin"
    ></calendar>
    <div v-else class="text-center py-5 text-muted">
      <div class="spinner-border spinner-border-sm me-2" role="status"></div>
      Loading calendar...
    </div>

    <!-- Schedule Config Modal -->
    <b-modal v-model="showScheduleModal" size="lg" title-class="fw-semibold" modal-class="custom-dark-modal" scrollable>
      <template #title>
        <div v-if="isTeacherConfig">
          <i class="ri-book-open-line align-bottom me-1"></i> Teacher Classes Schedule Config
        </div>
        <div v-else>
          <i class="ri-calendar-settings-line align-bottom me-1"></i> Interview Schedule Config
        </div>
      </template>

      <!-- Department selector (ONLY for Super Admin) -->
      <div v-if="!isTeacherConfig && isSuperAdmin" class="mb-3">
        <label class="form-label">Department</label>
        <select class="form-select" style="max-width:220px;" v-model.number="scheduleDeptId" @change="loadSchedule">
          <option v-for="dept in departments" :key="dept.departmentID" :value="dept.departmentID">{{ dept.name }}</option>
        </select>
      </div>

      <div v-if="scheduleLoading" class="text-center py-4">
        <div class="spinner-border text-success" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div v-else>
        <div class="row mb-3 g-3">
          <div class="col-md-7">
            <label class="form-label fs-12 text-muted text-uppercase mb-1"><i class="ri-link me-1"></i> {{ isTeacherConfig ? 'Class Meeting Link' : 'Interview Meeting Link' }}</label>
            <input type="text" class="form-control" v-model="meetingLink" placeholder="e.g., https://zoom.us/j/... or Google Meet" />
          </div>
          <div class="col-md-5">
            <label class="form-label fs-12 text-muted text-uppercase mb-1"><i class="ri-lock-line me-1"></i> Password / PIN</label>
            <input type="text" class="form-control" v-model="meetingPassword" placeholder="Optional passcode" />
          </div>
        </div>

        <div class="row g-3">
          <div v-for="day in days" :key="day" class="col-lg-6">
          <div class="card mb-0 border">
            <div class="card-header p-2 d-flex align-items-center justify-content-between">
              <span class="fw-semibold text-uppercase fs-12">{{ dayLabels[day] }}</span>
              <span v-if="scheduleConfig[day] && scheduleConfig[day].length"
                    :class="isTeacherConfig ? 'badge bg-primary-subtle text-primary' : 'badge bg-success-subtle text-success'">
                {{ scheduleConfig[day].length }} slot{{ scheduleConfig[day].length > 1 ? 's' : '' }}
              </span>
              <span v-else class="badge bg-secondary">Off</span>
            </div>
            <div class="card-body p-2">
              <div v-if="scheduleConfig[day] && scheduleConfig[day].length" class="d-flex flex-wrap gap-2 mb-2">
                <span v-for="(time, idx) in scheduleConfig[day]" :key="time" :class="isTeacherConfig ? 'slot-tag-primary' : 'slot-tag'">
                  {{ formatSlot(time) }}
                  <button type="button" class="remove-btn" @click="removeSlot(day, idx)">&times;</button>
                </span>
              </div>
              <div v-else class="text-muted fs-12 mb-2 fst-italic">
                No slots — day will be hidden in the calendar.
              </div>

              <div class="input-group input-group-sm">
                <input type="time" class="form-control" style="max-width:120px;" v-model="newSlot[day]" />
                <button :class="isTeacherConfig ? 'btn btn-outline-primary' : 'btn btn-outline-success'" type="button" @click="addSlot(day)">+</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <template #footer>
        <div class="d-flex w-100 align-items-center justify-content-end gap-2">
          <span v-if="scheduleSaved" class="text-success fs-12 fw-medium me-2">
            <i class="ri-check-line align-middle"></i> Saved
          </span>
          <button type="button" class="btn btn-light" @click="showScheduleModal = false">Close</button>
          <button type="button" :class="isTeacherConfig ? 'btn btn-primary' : 'btn btn-success'" @click="saveSchedule" :disabled="scheduleSaving">
            <i v-if="scheduleSaving" class="mdi mdi-loading mdi-spin me-1"></i>
            <i v-else class="ri-save-line align-middle me-1"></i> Save
          </button>
        </div>
      </template>
    </b-modal>

  </Layout>
</template>

<style scoped>
.slot-tag {
  display: inline-flex; align-items: center; gap: 4px;
  background: var(--vz-success-bg-subtle, #d1e7dd); color: var(--vz-success, #0f5132);
  border: 1px solid var(--vz-success-border-subtle, #a3cfbb);
  border-radius: 4px; padding: 2px 8px;
  font-size: 0.78rem; font-weight: 600;
}
.slot-tag .remove-btn { background: none; border: none; color: inherit; padding: 0 0 0 2px; line-height: 1; cursor: pointer; opacity: .7; }
.slot-tag .remove-btn:hover { opacity: 1; color: #dc3545; }

.slot-tag-primary {
  display: inline-flex; align-items: center; gap: 4px;
  background: var(--vz-primary-bg-subtle, #cfe2ff); color: var(--vz-primary, #084298);
  border: 1px solid var(--vz-primary-border-subtle, #b6d4fe);
  border-radius: 4px; padding: 2px 8px;
  font-size: 0.78rem; font-weight: 600;
}
.slot-tag-primary .remove-btn { background: none; border: none; color: inherit; padding: 0 0 0 2px; line-height: 1; cursor: pointer; opacity: .7; }
.slot-tag-primary .remove-btn:hover { opacity: 1; color: #dc3545; }
</style>
<style>
[data-layout-mode="dark"] .custom-dark-modal .modal-content {
  background-color: var(--vz-modal-bg, #212529) !important;
  color: var(--vz-body-color, #ced4da) !important;
  border: 1px solid var(--vz-border-color, #32383e) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5) !important;
}
[data-layout-mode="dark"] .custom-dark-modal .modal-header {
  background-color: var(--vz-modal-bg, #212529) !important;
  border-bottom: 1px solid var(--vz-border-color, #32383e) !important;
}
[data-layout-mode="dark"] .custom-dark-modal .modal-body {
  background-color: var(--vz-modal-bg, #212529) !important;
}
[data-layout-mode="dark"] .custom-dark-modal .modal-footer {
  background-color: var(--vz-modal-bg, #212529) !important;
  border-top: 1px solid var(--vz-border-color, #32383e) !important;
}
[data-layout-mode="dark"] .custom-dark-modal .modal-title {
  color: var(--vz-heading-color, #f3f6f9) !important;
}
[data-layout-mode="dark"] .custom-dark-modal .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}
</style>
